import { inject, Injectable } from '@angular/core';
import {
  ChatbotByIdData,
  ChatbotIA,
  ChatbotInitialData,
  ChatMessage,
} from '../interface/chatbot.interface';
import { HttpService } from '../../../../Services/http.service';
import { IResponseApiGeneric } from '@/interface/general/IResponseApi';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ChatbotService {
  private urlGetInitialData = 'ChatBot/GetInitialData';
  private urlGetOptions = 'ChatBot/GetPreguntaById?Id=';
  private urlGetById = 'ChatBot/GetById?IdMenuChatBot=';
  private urlIA = 'ChatBot/ConsultarIA?mensaje=';

  httpService = inject(HttpService);

  constructor() {}

  getInitialData(): Observable<ChatMessage> {
    return this.httpService
      .Get<IResponseApiGeneric<ChatbotInitialData>>(this.urlGetInitialData)
      .pipe(
        map((res) => {
          const data = res.data;
          return {
            text: data.MensajeInicial || 'Sin mensaje inicial',
            sender: 'bot',
            timestamp: new Date(),
            options: data.ListaMenuChatBot.map((item) => ({
              id: item.Id,
              text: item.Nombre,
            })),
          };
        }),
      );
  }

  getByIdOptions(id: number): Observable<ChatMessage> {
    return this.httpService
      .Get<IResponseApiGeneric<ChatbotByIdData[]>>(`${this.urlGetOptions}${id}`)
      .pipe(map((res) => this.mapToMessageOptions(res.data)));
  }

  private mapToMessageOptions(data: ChatbotByIdData[]): ChatMessage {
    return {
      text: 'Selecciona una opción:',
      sender: 'bot',
      timestamp: new Date(),
      options: data.map((item) => ({
        id: item.Id,
        text: item.Mensaje,
      })),
    };
  }

  getById(idMenu: number, id: number): Observable<ChatMessage> {
    return this.httpService
      .Get<
        IResponseApiGeneric<ChatbotByIdData>
      >(`${this.urlGetById}${idMenu}&Id=${id}`)
      .pipe(map((res) => this.mapToMessage(res.data)));
  }

  private mapToMessage(data: ChatbotByIdData): ChatMessage {
    const textoFormateado = (data?.Respuesta || 'Sin respuesta').replace(
      /\r\n/g,
      '<br>',
    );

    return {
      text: textoFormateado,
      sender: 'bot',
      timestamp: new Date(),
      options: [],
    };
  }

  postconsultarIA(mensaje: ChatbotIA): Observable<IResponseApiGeneric<any>> {
    return this.httpService.Post<IResponseApiGeneric<any>>(mensaje, this.urlIA);
  }

  consultarIA(texto: string): Observable<ChatMessage> {
    return this.postconsultarIA({ mensaje: texto }).pipe(
      map((res) => ({
        text: res.data || 'Sin respuesta de IA',
        sender: 'bot',
        timestamp: new Date(),
        options: [],
      })),
    );
  }
}
